module.exports = __webpack_public_path__ + "img/price.6fd95a35.png";